import { Button, Loader, TextInput } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import type { z } from "zod";
import { ShareWhiteboardCombobox } from "./share-whiteboard-combobox";
import { ShareWhiteboardFieldGroup } from "./share-whiteboard-field-group";
import type { inviteFormSchema } from "./whiteboard-invite-schema";

interface EmailInputSectionProps {
	form: UseFormReturnType<z.infer<typeof inviteFormSchema>>;
	handleSubmit: (event?: React.FormEvent<HTMLFormElement>) => void;
	isSubmitting: boolean;
	enabled?: boolean;
	stats?: { available: boolean };
}

export function EmailInputSection({
	form,
	handleSubmit,
	isSubmitting,
	enabled = true,
	stats,
}: EmailInputSectionProps) {
	const emailsValid =
		form.errors.emails === undefined && form.values.emails.length > 0;
	const canInvite = enabled && stats?.available !== false;

	return (
		<>
			<ShareWhiteboardFieldGroup>
				<ShareWhiteboardCombobox
					value={form.values.selectedRole}
					onChange={(value) => form.setFieldValue("selectedRole", value)}
					availableOptions={["Viewer", "Editor"]}
					disableEditor={!canInvite}
				/>

				<TextInput
					name="emails"
					key={form.key("emails")}
					{...form.getInputProps("emails")}
					classNames={{ input: "focus:border-brand-primary" }}
					placeholder="Enter emails separated by commas"
					inputWrapperOrder={["error", "input"]}
					error={form.errors.emails}
					className="w-full"
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							handleSubmit();
						}
					}}
				/>
			</ShareWhiteboardFieldGroup>

			<Button
				variant="filled"
				color="var(--ui-color-brand-primary)"
				radius="sm"
				fullWidth
				disabled={!emailsValid || !canInvite}
				onClick={() => {
					handleSubmit();
				}}
			>
				{isSubmitting ? (
					<Loader size="xs" color="var(--ui-color-text-muted)" />
				) : (
					"Invite Members"
				)}
			</Button>
		</>
	);
}
